module.exports = __webpack_public_path__ + "static/media/ico-whatsapp.1474c8cb.jpg";